export const SUPER_ADMIN_LOAD = 'SUPER_ADMIN_LOAD'
export const SUPER_ADMIN_LOAD_FULFILLED = 'SUPER_ADMIN_LOAD_FULFILLED'
export const SUPER_ADMIN_LOAD_REJECTED = 'SUPER_ADMIN_LOAD_REJECTED'
